export enum EntityOnboardingTooltips {
  general_tooltip = 'general_tooltip',
  meet_create_general = 'meet_create_general',
  task_create_general = 'task_create_general',
  event_create_general = 'event_create_general',
  reminder_create_general = 'reminder_create_general',
  appointment_create_general = 'appointment_create_general',
  work_create_general_general = 'work_create_general_general',
  personal_create_general = 'personal_create_general',
  garage_create_general = 'garage_create_general',
  property_create_general = 'property_create_general',
  education_create_general = 'education_create_general',
  pets_create_general = 'pets_create_general',
  family_create_general = 'family_create_general',
  family_main_page_filters = 'family_main_page_filters',
  family_main_page_card = 'family_main_page_card',
  family_view_general_info = 'family_view_general_info',
}
